import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import CircularProgress from '@mui/joy/CircularProgress'

export const Loading = ({ message }) => {
    let msg = message ? message : 'Loading...'

    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography color="neutral" level="body-lg">
                {msg}
            </Typography>
            <CircularProgress />
        </Box>
    )
}
